import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change. Without this, clicking a footer
// link while at the bottom of the page lands you at the bottom of the next
// page — which feels like the link didn't work.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
